/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S5_Phone_AfterInputs */

const tr_hakkimizda_s5_phone_after = /** @type {(inputs: Hakkimizda_S5_Phone_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Pazartesi-Cuma 09:00-18:00).`)
};

const en_hakkimizda_s5_phone_after = /** @type {(inputs: Hakkimizda_S5_Phone_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Monday-Friday 09:00-18:00).`)
};

const de_hakkimizda_s5_phone_after = /** @type {(inputs: Hakkimizda_S5_Phone_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Montag-Freitag 09:00-18:00).`)
};

const ru_hakkimizda_s5_phone_after = /** @type {(inputs: Hakkimizda_S5_Phone_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (понедельник-пятница 09:00-18:00).`)
};

/**
* | output |
* | --- |
* | "(Monday-Friday 09:00-18:00)." |
*
* @param {Hakkimizda_S5_Phone_AfterInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s5_phone_after = /** @type {((inputs?: Hakkimizda_S5_Phone_AfterInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S5_Phone_AfterInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s5_phone_after(inputs)
	if (locale === "de") return de_hakkimizda_s5_phone_after(inputs)
	if (locale === "ru") return ru_hakkimizda_s5_phone_after(inputs)
	return tr_hakkimizda_s5_phone_after(inputs)
});